import React, { Fragment } from 'react';

import { Formik, Field, FieldArray } from 'formik';
import * as Yup from 'yup';

import TrashIcon from 'Assets/icons/trash.svg';

const EvaluationTemplateCreateSchema = Yup.object().shape({
    name: Yup.string()
        .required($t('This value is required'))
        .min(2, $t('The name must contain at least 2 characters'))
        .max(191, $t('The name must be no more than 191 characters')),
    companies: Yup.array().of(
        Yup.string()
            .required($t('This value is required'))
            .min(2, $t('The name must contain at least 2 characters'))
            .max(191, $t('The name must be no more than 191 characters')),
    ),
});

export default function EvaluationTemplateCreateForm(props) {
    return (
        <Formik
            initialValues={{
                name: '',
                companies: [''],
            }}
            validationSchema={EvaluationTemplateCreateSchema}
            onSubmit={(values, actions) => {
                axios
                    .post(props.storeUrl, values)
                    .then((response) => {
                        const { template } = response.data;
                        const url = props.editUrl.replace('TEMPLATE_UUID', template.uuid);
                        window.location.href = url;
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <div className="inbud-card tw-mb-3">
                    <div className="tw-grid tw-grid-flow-col tw-auto-cols-fr tw-gap-x-3 tw-mt-6">
                        <div className="tw-grid tw-gap-4 tw-grid-cols-2">
                            <label className="tw-col-span-1 tw-text-base" htmlFor="templateName">
                                {$t('Template Name')} <span className="tw-text-red-500">*</span>
                            </label>
                            <Field
                                type="text"
                                className={`tw-w-full tw-rounded-lg tw-bg-input-background tw-text-input-text tw-font-semibold tw-border-0 ${
                                    errors.name && touched.name ? 'tw-border tw-border-red-500' : ''
                                }`}
                                name="name"
                                placeholder={$t('Template Name')}
                            />
                            {errors.name && touched.name && <div className="tw-col-start-2 tw-text-red-500">{errors.name}</div>}
                        </div>
                    </div>
                    <FieldArray
                        name="companies"
                        render={(arrayHelpers) => (
                            <div>
                                {values.companies && values.companies.length > 0 ? (
                                    values.companies.map((company, index) => (
                                        <Fragment key={index}>
                                            <div className="tw-grid tw-grid-flow-col tw-auto-cols-fr tw-gap-x-3 tw-mt-6">
                                                <div className="tw-grid tw-gap-4 tw-grid-cols-2">
                                                    <label className="tw-col-span-1 tw-text-base" htmlFor="templateName">
                                                        {$t('Company Name')} {index + 1} <span className="tw-text-red-500">*</span>
                                                    </label>
                                                    <div className={'tw-flex tw-flex-row'}>
                                                        <Field
                                                            type="text"
                                                            className={`tw-w-full tw-rounded-lg tw-bg-input-background tw-text-input-text tw-font-semibold tw-border-0 ${
                                                                errors.companies &&
                                                                errors.companies[index] &&
                                                                ((touched.company && touched.company[index]) || (touched.companies && touched.companies[index]))
                                                                    ? 'tw-border tw-border-red-500'
                                                                    : ''
                                                            }`}
                                                            name={`companies.${index}`}
                                                            placeholder={$t('Company Name')}
                                                        />
                                                        <button
                                                            className="tw-flex tw-flex-col tw-ml-2 tw-justify-center tw-items-center tw-text-xs"
                                                            onClick={() => arrayHelpers.remove(index)}
                                                        >
                                                            <TrashIcon className="tw-text-red-500 tw-w-3 tw-h-3" />
                                                        </button>
                                                    </div>
                                                    {(errors.companies && errors.companies[index] && touched.company && touched.company[index]) ||
                                                        (touched.companies && touched.companies[index] && (
                                                            <div className="tw-col-start-2 tw-text-red-500">{errors.name}</div>
                                                        ))}
                                                </div>
                                            </div>
                                            {values.companies.length - 1 === index && (
                                                <div className={'tw-flex tw-flex-row tw-justify-end tw-mt-3'}>
                                                    <button type="button" className="button primary" onClick={() => arrayHelpers.push('')}>
                                                        {$t('Add a company')}
                                                    </button>
                                                </div>
                                            )}
                                        </Fragment>
                                    ))
                                ) : (
                                    <div className={'tw-flex tw-flex-row tw-justify-end tw-mt-3'}>
                                        <button type="button" className="button primary" onClick={() => arrayHelpers.push('')}>
                                            {$t('Add a company')}
                                        </button>
                                    </div>
                                )}
                                <div className="tw-mt-3">
                                    <button
                                        type="button"
                                        className="button primary"
                                        disabled={isSubmitting || values.companies.length === 0}
                                        onClick={handleSubmit}
                                    >
                                        {$t('Submit')}
                                    </button>
                                </div>
                            </div>
                        )}
                    />
                </div>
            )}
        </Formik>
    );
}
